export const prepAndTrimDescription = (
  groupName: string,
  trimLength?: number
) => {
  return `Snap!Spend:${groupName}`.trim().substring(0, trimLength || 22);
};
